// extracted by mini-css-extract-plugin
export var dropdownIcon = "_l7-6";
export var imgContainer = "_l7-3";
export var menuIcon = "_l7-5";
export var pillWrapper = "_l7-2";
export var pillsContainer = "_l7-1";
export var subscriptionCard = "_l7-0";
export var subscriptionLogo = "_l7-4";